<router-outlet></router-outlet>

<a href="https://wa.me/971585727931" class="whatsapp-widget" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp">
  <i class="fab fa-whatsapp"></i>
</a>
